import React from 'react'
import { Navigate, Outlet } from "react-router-dom";
import { Alert, Box, Button, CircularProgress } from '@mui/material';
import useMemberAccess from '../../hooks/useMemberAccess';

const ProtectedRoutes = () => {

  const access = useMemberAccess();
  if (access.loading) return <Box py={8} textAlign="center"><CircularProgress /></Box>;
  if (!access.hasPremiumAccess && access.storeError) return <Box py={8}><Alert severity="warning" action={<Button onClick={access.refreshMembership}>Retry</Button>}>{access.storeError}</Alert></Box>;
  return access.hasPremiumAccess ? <Outlet /> : <Navigate to="/pricing" replace />;
}

export default ProtectedRoutes
